import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

import { handleValidations } from "../../rules/handle-validations.rules";

@Component({
  selector: 'dialog-form',
  templateUrl: 'dialog-form.component.html',
  styleUrls: ['dialog-form.component.scss']
})
export class DialogForm {
  private form: FormGroup;
  private formJson: any;
  constructor(@Inject(MAT_DIALOG_DATA) data, public dialogRef: MatDialogRef<DialogForm>) {
    this.form = data.form;
    this.formJson = data.formJson;
    handleValidations(this.formJson, this.form);
    this.handleValidations()
  }

  handleValidations() {
    for (let form of this.formJson) {
      for (let field of form.parameters) {
        if (field["modal-only"]) field["modal-only"] = false;
      }
    }
  }

}
